<template>
	<div class="course_bottomRight">
		<div class="lab_titleNormal">实验讨论<span class="primaryColor">（共{{commontTotal}}条）</span></div>
		<div class="course_tabNormal">
			<div class="course_commInput lab_commInput">
				<div class="course_inputBox">
					<textarea v-model="commontinfo" class="beautifulScroll" placeholder="发表评论，文明上网理性发言"></textarea>
				</div>
				<div class="course_inputBtn">
					<el-button type='primary' @click="commontChapters" :disabled='dataloading'>发表评论</el-button>
				</div>
			</div>
		</div>
		<div class="course_commNav">
			<div class="course_commNavItem lab_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div class="course_commBox">
			<emptymain :emptytext="'暂无讨论'" :emptylist='commontList'></emptymain>
			<div class="course_commItem" v-for='(item,index) in commontList'>
				<div class="course_commIcon">
					<img :src="baseurl + item.iconFile" v-if="item.iconFile" />
					<img src="@/images/1.png" v-else/>
				</div>
				<div class="course_commUser">{{item.realname}}</div>
				<div class="course_commText">{{item.content}}</div>
				<div class="course_commInfo clearfix">
					<span class="l">{{item.updateTime |formatTime}}</span>
					<span class="r course_commLike" :class="item.isLiked=='1'?'active':''" @click='changelike(item,index)'>
						{{item.isLiked=='1'?'已赞':'点赞'}}({{item.likeCount || 0}})
					</span>
					<span class="r course_commOprn" @click='changeReply(item,index)'>回复</span>
				</div>
				<div class="course_replyInput" v-if="commentId == item.id && replyType=='comment'">
					<div class="course_commIcon">
						<img :src="baseurl + item.iconFile" v-if="item.iconFile" />
						<img src="@/images/1.png" v-else/>
					</div>
					<div class="course_replytextBox">
						<textarea v-model="replyContent" class="beautifulScroll" :placeholder="replyPlaceholder"></textarea>
					</div>
					<div class="course_replyBtn">
						<el-button type='primary' @click="replycreate" :disabled='dataloading'>发表评论</el-button>
					</div>
				</div>
				<div class="course_replyBox" v-if="item.replies && item.replies.length>0">
					<div class="course_commItem" v-if='replyindex<=2' v-for="(reply,replyindex) in item.replies">
						<div class="course_commIcon">
							<img :src="baseurl + reply.iconFile" v-if="reply.iconFile" />
							<img src="@/images/1.png" v-else/>
						</div>
						<div class="course_commText">
							<span class="pointer primaryColor" @click="changeReReply(item,index,reply,1)">{{reply.userName}}</span>
							<span class="course_replySpan">回复</span>
							<span class="pointer primaryColor" @click="changeReReply(item,index,reply,2)">{{reply.replyToName}}</span>
							<span class="course_replySpan">{{reply.content}}</span>
						</div>
						<div class="course_commInfo clearfix">
							<span class="l">{{reply.updateTime |formatTime}}</span>
							<span class="pointer l course_commOprn" @click='changeReReply(item,index,reply,1)'>回复</span>
						</div>
						<div class="course_replyInput" v-if="replyId == reply.id && replyType=='reply'">
							<div class="course_commIcon">
								<img :src="baseurl + item.iconFile" v-if="item.iconFile" />
								<img src="@/images/1.png" v-else/>
							</div>
							<div class="course_replytextBox">
								<textarea v-model="replyContent" class="beautifulScroll" :placeholder="replyPlaceholder"></textarea>
							</div>
							<div class="course_replyBtn">
								<el-button type='primary' @click="replycreate" :disabled='dataloading'>发表评论</el-button>
							</div>
						</div>
					</div>
					<div class="course_commItem" v-show="item.show" v-if='replyindex>2' v-for="(reply,replyindex) in item.replies">
						<div class="course_commIcon">
							<img :src="baseurl + reply.iconFile" v-if="reply.iconFile" />
							<img src="@/images/1.png" v-else/>
						</div>
						<div class="course_commText">
							<span class="pointer primaryColor" @click="changeReReply(item,index,reply,1)">{{reply.userName}}</span>
							<span class="course_replySpan">回复</span>
							<span class="pointer primaryColor" @click="changeReReply(item,index,reply,2)">{{reply.replyToName}}</span>
							<span class="course_replySpan">{{reply.content}}</span>
						</div>
						<div class="course_commInfo clearfix">
							<span class="l">{{reply.updateTime |formatTime}}</span>
							<span class="pointer l course_commOprn" @click='changeReReply(item,index,reply,1)'>回复</span>
						</div>
						<div class="course_replyInput" v-if="replyId == reply.id && replyType=='reply'">
							<div class="course_commIcon">
								<img :src="baseurl + item.iconFile" v-if="item.iconFile" />
								<img src="@/images/1.png" v-else/>
							</div>
							<div class="course_replytextBox">
								<textarea v-model="replyContent" class="beautifulScroll" :placeholder="replyPlaceholder"></textarea>
							</div>
							<div class="course_replyBtn">
								<el-button type='primary' @click="replycreate" :disabled='dataloading'>发表评论</el-button>
							</div>
						</div>
					</div>
					<div class="course_replyHasMore" v-if="item.replies && item.replies.length>0">
						<span class="course_replycount">共{{item.replies.length}}条</span>
						<span class="pointer primaryColor" @click='showmore(item,index)' v-show="!item.show" v-if='item.replyCount>3'>显示更多</span>
						<span class="pointer primaryColor" @click='hidemore(item,index)' v-show="item.show">收起</span>
					</div>
				</div>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="commontPageChange" :current-page="commontPage" :page-size="limit" layout="  prev, pager, next, jumper" :total="commontTotal">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth'
	import { getUserById, getInfo } from '@/api/user.js'
	import { vrcommentList, vrcommentLike, vrcommentCancelLikes, vrcommentPublish, vrreplyPublish, vrreplyService } from '@/api/comment.js'
	export default {
		props: {
			vrDetailId: String,
		},
		data() {
			return {
				dataloading: false,
				activeName: '1',
				commNavs: [{
					name: '全部评论',
					id: '1'
				}],
				limit: 10,
				//评论
				commontPage: 1,
				commontTotal: 0,
				commontList: [],
				commontinfo: '',
				//回复
				reply: false,
				commentId: "",
				replyId: "",
				replyType: "",
				replyContent: "",
				replyTo: "",
				replyIndex: -1,
				replyPlaceholder: '请输入内容',
			}
		},
		created() {
			this.getMyUserInfo();
		},
		methods: {
			getMyUserInfo() {
				getInfo().then(res => {
					if(res.code == 'OK') {
						this.userinfo = res.data;
						this.getCommentList();
					}
				})
			},
			commontPageChange(current) {
				this.commontPage = current;
				this.getCommentList();
			},
			getCommentList() {
				var data = {
					limit: this.limit,
					current: this.commontPage,
					vrDetailId: this.vrDetailId,
				}
				vrcommentList(data).then(res => {
					if(res.code == "OK") {
						this.commontList = res.data.records;
						this.commontTotal = res.data.total;
					}
				})
			},
			changelike(item, index) {
				var data = {
					commentId: item.id
				}
				var commontList = this.commontList;
				if(item.isLiked != '1') {
					vrcommentLike(data).then(res => {
						if(res.code == "OK") {
							commontList[index].isLiked = '1';
							commontList[index].likeCount = commontList[index].likeCount * 1 + 1;
							this.$set(commontList, index, commontList[index]);
						}
					})
				} else {
					vrcommentCancelLikes(data).then(res => {
						if(res.code == "OK") {
							commontList[index].isLiked = false;
							commontList[index].likeCount = commontList[index].likeCount * 1 - 1 < 0 ? 0 : commontList[index].likeCount * 1 - 1;
							this.$set(commontList, index, commontList[index]);
						}
					})
				}

			},
			commontChapters() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				var commontinfo = this.commontinfo;
				if(commontinfo != '') {
					var data = {
						content: commontinfo,
						vrDetailId: this.vrDetailId
					}
					vrcommentPublish(data).then(res => {
						if(res.code == "OK") {
							var data = res.data;
							data.realname = this.userinfo.name;
							data.replies = [];
							this.commontList.unshift(data);
							this.commont = false;
							this.commontinfo = '';
							this.$message.success('发布成功');
							this.$emit('commentAdd');
							this.commontTotal++;
						} else {
							this.$message.error('发布失败，请稍后重试')
						}
					})
				} else {
					this.$message.error('请输入内容')
				}
			},
			showmore(item, index) {
				var commontList = this.commontList;
				var data = {
					commentId: commontList[index].id,
				}
				vrreplyService(data).then(res => {
					if(res.code == "OK") {
						var morereply = res.data.splice(3);
						commontList[index].replies = commontList[index].replies.concat(morereply);
						commontList[index].show = true;
						this.$set(commontList, index, commontList[index])
					}
				})
			},
			hidemore(item, index) {
				var commontList = this.commontList;
				commontList[index].show = false;
				this.$set(commontList, index, commontList[index])
			},
			changeReReply(item, index, reply, type) {
				if(this.replyId == reply.id) {
					this.closeReply()
				} else {
					this.replyIndex = index;
					this.commentId = item.id;
					this.replyId = reply.id;
					this.reply = true;
					this.replyType = 'reply';
					if(type == 1) {
						this.replyTo = reply.userId;
						this.replyPlaceholder = '回复' + reply.userName + '：';
					}
					if(type == 2) {
						this.replyTo = reply.replyTo;
						this.replyPlaceholder = '回复' + reply.replyToName + '：';
					}
				}
			},
			changeReply(item, index) {
				if(this.commentId == item.id) {
					this.closeReply()
				} else {
					this.replyIndex = index;
					this.replyTo = item.userId;
					this.commentId = item.id;
					this.replyPlaceholder = '请输入信息';
					this.reply = true;
					this.replyType = 'comment'
				}
			},
			closeReply() {
				this.replyIndex = -1;
				this.replyTo = '';
				this.commentId = '';
				this.replyContent = '';
				this.replyId = '';
				this.replyType = '';
				this.replyPlaceholder = '请输入信息';
				this.reply = false;
			},
			replycreate() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				var replyContent = this.replyContent;
				if(replyContent && replyContent != '') {
					var data = {
						commentId: this.commentId,
						replyTo: this.replyTo,
						content: this.replyContent,
					}
					vrreplyPublish(data).then(res => {
						if(res.code == "OK") {
							this.$message({
								title: '提示',
								message: '回复成功',
								type: 'success'
							});
							this.commontList[this.replyIndex].replies.unshift(res.data);
							this.commontList[this.replyIndex].replyCount ? this.commontList[this.replyIndex].replyCount++ : this.commontList[this.replyIndex].replyCount = 1;
						} else {
							this.$message({
								title: '提示',
								message: '回复失败，请稍后重试',
								type: 'info'
							});
						}
						this.closeReply()
					})
				} else {
					this.$message({
						title: '提示',
						message: '请输入回复内容',
						type: 'info'
					});
				}
			},
		},
	}
</script>